import { render } from "./Contact.vue?vue&type=template&id=3f6b7cbe&scoped=true&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=3f6b7cbe&lang=scss&scoped=true"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6b7cbe"]])

export default __exports__